// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sS3i","newExpiryDate":"styles_newExpiryDate__3MlG5","footer":"styles_footer__3uM75"};